module.exports = __webpack_public_path__ + "img/logos-apoio-eureciclo-rodape.c91b460f.png";